import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    customScrollbarContainer: {
      height: '26vh',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-thumb': {
        height: '40px',
        borderRadius: '22.5px',
        backgroundColor: '#EDEEF1',
      },
    },
    customScrollbarContainer1: {
      height: '75vh',
      overflowY: 'auto',
    },
    customScrollbarContainerall: {
      height: '26vh',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-thumb': {
        height: '40px',
        borderRadius: '22.5px',
        backgroundColor: '#EDEEF1',
      },
    },
    headerContainer: {
      backgroundColor: '#5981FF',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '9px !important',
      padding: '30px 30px 20px 30px',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        width: '95%',
      },
      [theme.breakpoints.down('sm')]: {
        width: '90%',
      },
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        padding: '20px 20px 10px 20px',
      },
    },
    text: {
      fontSize: '15px !important',
      fontWeight: '600 !important',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        fontSize: '16px !important',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px !important',
      },
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '11px !important',
      },
    },
    headerText: {
      fontSize: '15px !important',
      fontWeight: '600 !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '11px !important',
      },
    },
    subquestion: {
      // padding: '12px',
      borderRadius: '12px',
      display: 'flex',
      flexDirection: 'column',
    },
    searchBox: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(2),
      width: '60%',
    },
    fontsubq: {
      fontSize: '12px !important',
      fontWeight: '500 !important',
      textAlign: 'start',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '9px !important',
      },
    },
    fontsuba: {
      fontSize: '12px !important',
      fontWeight: '400 !important',
      textAlign: 'left',
      padding: '0px 68px',
      color: '#373A45',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '9px !important',
      },
    },
    inputBase: {
      backgroundColor: 'white',
      borderRadius: '5px',
      padding: theme.spacing(1),
      flexGrow: 1,
    },
    cardDesign: {
      padding: '10px',
      borderRadius: '9px !important',
      boxShadow: 'none !important',
      marginTop: '20px',
      height: '32vh',
      [theme.breakpoints.up('xxl')]: {
        height: '27vh',
      },
      '@media (min-width: 1600px) and (max-width: 1679px)': {
        height: '29.2vh',
      },
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        height: '30vh !important',
      },
    },
    cardDesign1: {
      padding: '10px',
      borderRadius: '9px !important',
      boxShadow: 'none !important',
      marginTop: '10px',
      height: '82vh',
      [theme.breakpoints.up('xxl')]: {
        height: '82vh',
      },
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        height: '79vh',
      },
    },
    viewmoredesign: {
      margin: '10px 20px 0px 20px',
      padding: '10px',
      borderRadius: '12px !important',
      boxShadow: 'none !important',
    },
    RequestCard: {
      backgroundColor: '#FAB400 !important',
      cursor: 'pointer',
      color: 'White !important',
      borderRadius: '9px !important',
      textAlign: 'center',
      padding: '10px',
      height: '32vh',
      [theme.breakpoints.up('xxl')]: {
        height: '27vh',
      },
      '@media (min-width: 1600px) and (max-width: 1679px)': {
        height: '29.2vh',
      },
      marginTop: '20px',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        height: '30vh !important',
      },
      '@media (min-width:320px) and (max-width: 480px)': {
        marginTop: '10px !important',
      },
    },

    ComplainCard: {
      backgroundColor: '#fff !important',
      cursor: 'pointer',
      color: 'Black !important',
      borderRadius: '9px !important',
      textAlign: 'center',
      padding: '16px',
      height: '32vh',
      [theme.breakpoints.up('xxl')]: {
        height: '27vh',
      },
      '@media (min-width: 1600px) and (max-width: 1679px)': {
        height: '29.2vh',
      },
      marginTop: '20px',
      boxShadow: 'none !important',
      border: '1px solid #4B3776',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        height: '30vh !important',
      },
      '@media (min-width:320px) and (max-width: 480px)': {
        marginTop: '10px !important',
      },
    },
    RCtypo: {
      fontSize: '12px !important',
      fontWeight: '500 !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '11px !important',
      },
    },
    dilogHeader: {
      fontSize: '15px !important',
      fontWeight: '500 !important',
      marginBottom: '12px !important',
      borderBottom: '2px solid #BFCEFF',
      paddingBottom: '10px',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '13px !important',
      },
    },
    dilogtypo: {
      fontSize: '12px !important',
      fontWeight: '500 !important',
      marginBottom: '8px !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '11px !important',
      },
    },
    requestFlex: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    links: {
      color: '#FAB400 !important',
      fontSize: '12px !important',
      fontWeight: '500 !important',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      cursor: 'pointer',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },
    },
    rsCard: {
      padding: '6px !important',
      margin: '10px 0px !important',
      backgroundColor: '#F6F8FB !important',
      boxShadow: 'none !important',
      borderRadius: '12px !important',
      cursor: 'pointer',
    },
    RequestMainCard: {
      backgroundColor: 'white',
      margin: '20px 0px 0px 25px',
      padding: '10px 20px',
      borderRadius: '12px',
      height: '720px',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        height: '60px',
        borderRadius: '30px',
        backgroundColor: '#7495FF',
      },
    },
    dynamicheight: {
      backgroundColor: 'white',
      margin: '20px 0px 0px 25px',
      padding: '0px 20px',
      borderRadius: '12px',
      height: '50vh',
    },
    RequestMainCard1: {
      backgroundColor: 'white',
      padding: '20px 20px',
      borderRadius: '9px !important',
      boxShadow: 'none !important',
      height: '83vh',
      textAlign: 'left',
    },
    borderText: {
      fontSize: '15px',
      fontWeight: '600 !important',
      borderBottom: '1px solid #BFCEFF',
      display: 'flex',
      padding: '10px 0px',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '12px !important',
      },
    },
    marginToppx: {
      marginTop: '10px !important',
      paddingBottom: '15px !important',
    },
    requestStypoh: {
      fontSize: '12px',
      fontWeight: '600 !important',
      display: 'flex',
      textAlign: 'left',
      // marginBottom: '10px !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },
    },
    requestStypod: {
      fontSize: '12px',
      fontWeight: '400 !important',
      display: 'flex',
      textAlign: 'left',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },
    },
    subquestionHeader: {
      display: 'flex',
      fontWeight: '500 !important',
      marginBottom: '12px',
    },
    subHeaderQuestion: {
      fontSize: '16px',
      fontWeight: '400 !important',
      color: '#8C8E94',
      display: 'flex',
    },
    taggedHeader: {
      display: 'flex',
      fontSize: '24px',
      fontWeight: '500 !important',
      margin: '17px 0px',
    },
    boxRounded: {
      backgroundColor: '#EAEFFF',
      padding: '10px 12px !important',
      textAlign: 'center',
      fontSize: '16px !important',
      fontWeight: '500 !important',
      borderRadius: '16px',
      color: '#1A358C',
    },
    ProfileSettings: {
      backgroundColor: '#EAEFFF',
      padding: '24px',
      borderRadius: '16px',
    },
    ProfileTyo: {
      display: 'flex',
      fontSize: '20px !important',
      fontWeight: '500 !important',
      paddingBottom: '10px !important',
    },
    typoanswerprofile: {
      fontSize: '16px !important',
      fontWeight: '400 !important',
      color: '#373A45 !important',
      textAlign: 'left',
      paddingBottom: '15px !important',
    },
    profileButton: {
      display: 'flex !important',
      borderRadius: '6px !important',
      boxShadow: 'none !important',
    },
    borderGrid: {
      borderTop: '1px solid #BFCEFF',
      paddingTop: '12px',
      marginTop: '20px !important',
      height: '600px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        height: '60px',
        borderRadius: '30px',
        backgroundColor: '#7495FF',
      },
    },
    taggedBorder: {
      borderLeft: '1px solid #BFCEFF',
      marginLeft: '15px !important',
    },
    divprofile: {
      display: 'flex',
      flexDirection: 'column',
    },
    boxmargintop: {
      marginTop: '20px',
    },
    ulPadding: {
      padding: '0px 20px !important',
    },
    ticketCardMain: {
      width: '100%',
      marginTop: '10px !important',
      backgroundColor: '#fff',
      padding: '20px 20px 20px 20px !important',
      borderRadius: '9px !important',
      boxShadow: 'none !important',
      height: '35vh !important',
      '@media (min-width: 1440px) and (max-width: 1500px)': {
        height: '34.3vh !important',
      },
      '@media (min-width: 1536px) and (max-width: 1636px)': {
        height: '33.2vh !important',
      },
      '@media (min-width: 1920px) and (max-width: 2000px)': {
        height: '39vh !important',
      },
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        height: '28vh !important',
      },
      '@media (min-width:320px) and (max-width: 480px)': {
        padding: '0px !important',
      },
    },
    TicketHeader: {
      fontSize: '15px !important',
      fontWeight: '600 !important',
      textAlign: 'left',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '11px !important',
      },
    },
    statusTicket: {
      display: 'flex',
      fontSize: '12px !important',
      fontWeight: '500 !important',
      margin: '12px 0px !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10.5px !important',
      },
    },
    cardCOntentTicket: {
      borderRadius: '10px !important',
      boxShadow: 'none !important',
      backgroundColor: '#F6F8FB !important',
      cursor: 'pointer',
      marginTop: '10px',
    },
    ticketNumber: {
      color: '#373A45 !important',
      fontSize: '10.5px !important',
      fontWeight: '400 !important',
      display: 'flex',
      padding: '0px 10px !important',
      paddingTop: '10px !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '9.5px !important',
      },
    },
    ticketHeaderTypo: {
      padding: '0px 10px !important',
      display: 'flex',
      fontSize: '12px !important',
      fontWeight: '600 !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },
    },
    ticketDescription: {
      textAlign: 'left',
      padding: '0px 10px !important',
      color: '#373A45 !important',
      fontSize: '10.5px !important',
      fontWeight: '400 !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '9.5px !important',
      },
    },
    dateHeader: {
      fontSize: '10.5px !important',
      fontWeight: '500 !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '9.5px !important',
      },
    },
    ticketDate: {
      float: 'inline-start',
      marginLeft: '5px',
      fontSize: '10.5px',
      fontWeight: '600 !important',
      color: '#373A45',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '9.5px !important',
      },
    },
    greenStatusClosed: {
      backgroundColor: '#C1DCC3 !important',
      cursor: 'text !important',
      borderRadius: '12px !important',
      color: 'black !important',
      display: 'flex',
      padding: '4px !important',
      width: 80,
      paddingLeft: '10px !important',
    },
    greenStatus1: {
      backgroundColor: '#C1DCC3 !important',
      cursor: 'text !important',
      borderRadius: '12px !important',
      color: '#1F4E21 !important',
      display: 'flex',
      padding: '4px 12px',
      width: '58px',
      height: '21.5px',
      paddingLeft: '10px !important',
      fontWeight: '500 !important',
      fontSize: '12px !important',
    },
    PendingStatus: {
      backgroundColor: '#FEEBBE !important',
      cursor: 'text !important',
      borderRadius: '12px !important',
      color: '#695113 !important',
      display: 'flex',
      width: '100px',
      fontWeight: '500 !important',
      fontSize: '12px !important',
    },
    PendingStatus1: {
      width: '70px',
      height: '27px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#FEEBBE !important',
      cursor: 'text !important',
      borderRadius: '12px !important',
      color: '#695113 !important',
      fontWeight: '500 !important',
      fontSize: '12px !important',
    },
    resolvedStatus: {
      backgroundColor: '#FBEAEA !important',
      cursor: 'text !important',
      borderRadius: '6px !important',
      color: '#962121 !important',
      width: '147px',
      height: '36px !important',
      fontSize: '12px !important',
      fontWeight: '500 !important',
    },
    TicketCard: {
      padding: '15px 15px',
      boxShadow: 'none !important',
      borderRadius: '12px !important',
      height: '83vh',
    },
    ticketHeaderPreview: {
      display: 'flex',
      fontSize: '15px !important',
      fontWeight: '500 !important',
    },
    GridAlignBorder: {
      textAlign: 'left',
      borderBottom: '1px solid #BFCEFF',
      borderTop: '1px solid #BFCEFF',
      margin: '20px 0px !important',
      padding: '15px 2px 15px !important',
      width: '100% !important',
      gap: '45px',
    },
    headerCardinfo: {
      fontSize: '12px !important',
      fontWeight: '600 !important',
      marginBottom: '6px !important',
    },
    subTypoCardinfo: {
      fontSize: '12px !important',
      fontWeight: '500 !important',
      color: '#585A64 !important',
    },
    SenderTypo: {
      display: 'flex',
      fontSize: '10.5px !important',
      fontWeight: '400 !important',
    },
    AdminSender: {
      fontWeight: '600 !important',
      backgroundColor: '#F6F8FB !important',
    },
    Typdisplay: {
      display: 'flex',
      margin: '20px 0px !important',
      gap: '3px',
    },
    MessageBox: {
      borderRadius: '12px !important',
      padding: '15px 15px',
    },
    YouMessageBox: {
      backgroundColor: '#EAEFFF',
    },
    AdminMessageBox: {
      backgroundColor: '#F6F8FB',
    },
    headerchattypo: {
      display: 'flex',
      fontSize: '12px !important',
      fontWeight: '500 !important',
    },
    descriptionChatTypo: {
      textAlign: 'left',
      padding: '12px 0px !important',
      color: '#373A45 !important',
      fontSize: '12px !important',
      fontWeight: '400 !important',
    },
    replyicon: {
      color: '#373A45',
      fontWeight: '500 !important',
      fontSize: '16px !important',
      margin: '20px 20px !important',
      marginLeft: '80% !important',
    },
    customScrollbarContainerTicket: {
      height: '50vh',
      [theme.breakpoints.up('xxl')]: {
        height: '60vh',
      },
    },

    chatBox: {
      borderRadius: '12px !important',
      zIndex: '999 !important',
      left: '58% !important',
      top: '38% !important',
      '@media (max-width:600px)': {
        left: '0 !important',
        top: '25% !important',
      },
    },
    dialogPaper: {
      height: '100% !important',
    },
    headerContaine: {
      backgroundColor: '#3061FF',
      padding: '10px 15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    supportTeamAvatar: {
      width: '32px',
      height: '32px',
      marginRight: theme.spacing(2),
    },
    supportTeamName: {
      color: '#FFFFFF !important',
      fontWeight: '500 !important',
      fontSize: '20px !important',
    },
    closeButton: {
      color: 'white !important',
    },
    chatMessagesContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(2),
      maxHeight: '300px',
      overflowY: 'auto',
    },

    chatMessageAdmin: {
      backgroundColor: '#F6F8FB !important',
      borderRadius: '8px',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(2),
      maxWidth: '70%',
    },

    chatMessageUser: {
      backgroundColor: '#EAEFFF !important',
      borderRadius: '8px',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignSelf: 'flex-end',
      maxWidth: '70%',
    },
    centeredPlaceholder: {
      '& .MuiInputBase-input-MuiOutlinedInput-input': {
        paddingTop: '20px !important',
      },
    },
    customSelect: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '0.5px solid #B2B3B7 !important',
        padding: '0px 12px !important',
        borderRadius: '6px !important',
      },
      '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select': {
        padding: '10px !important',
      },
      '& .MuiInputBase-input': {
        fontSize: '12px',
      },
      '& .MuiOutlinedInput-root': {
        height: '36px',
      },
    },

    customTextArea: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '0.5px solid #B2B3B7 !important',
        padding: '0px 12px !important',
        borderRadius: '6px !important',
      },
      '& .MuiInputBase-input': {
        fontSize: '12px',
      },
    },
    customText: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '0.5px solid #B2B3B7 !important',
        padding: '0px 12px !important',
        borderRadius: '6px !important',
      },
      '& .MuiInputBase-input': {
        fontSize: '12px',
      },
      '& .MuiOutlinedInput-root': {
        height: '36px',
      },
      '& .MuiInputBase-input.MuiOutlinedInput-input': {
        padding: '10px !important',
      },
    },
    replyButton: {
      marginLeft: 'auto',
      marginRight: theme.spacing(2),
    },

    messageInputContainer: {
      display: 'flex',
      alignItems: 'center',
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(2),
    },
    dibtextflex: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #EDEEF1',
      width: '100%',
      padding: '0px 10px',
      borderRadius: '12px',
    },
    messageInput: {
      flex: 1,
      marginRight: theme.spacing(1),
    },
    notchedOutline: {
      border: 'none !important',
    },
    attachFilesIcon: {
      cursor: 'pointer',
    },
    'MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    noBorder: {
      border: 'none !important',
    },
    eventsCardBox: {
      borderRadius: '9px !important',
      backgroundColor: '#F6F8FB',
      padding: '5px',
    },
    postJobBtns: {
      width: '100%',
      borderRadius: '9px !important',
      padding: '9px !important',
      fontSize: '12px !important',
      fontWeight: '500 !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
        padding: '5px !important',
      },
    },
  })
);

export default useStyles;
